import { createParser } from 'nuqs';
import { useQueryStateFixed } from '@Utils/nuqs-fix';

export const FISH_TABS = [
  'overview',
  'activity',
  'messages',
  'tags',
  'profile',
  'membership',
  'employment',
];

export const ACTIVITY_SUB_TABS = [
  'history',
  'upcoming',
  'interactions',
  'admin',
];

const oneOf = (valid, fallback) =>
  createParser({
    parse: (v) => (valid.includes(v) ? v : null),
    serialize: (v) => v,
    eq: (a, b) => a === b,
  }).withDefault(fallback);

/**
 * Tab and Activity sub-tab selection, kept in the URL so a shift report or
 * look-ahead can deep link straight to a section of a fish's profile.
 */
export function useFishDetailParams() {
  const [tab, setTab] = useQueryStateFixed(
    'tab',
    oneOf(FISH_TABS, 'overview'),
  );
  const [activitySubTab, setActivitySubTab] = useQueryStateFixed(
    'sub',
    oneOf(ACTIVITY_SUB_TABS, 'history'),
  );

  return { tab, setTab, activitySubTab, setActivitySubTab };
}
